export default __webpack_public_path__ + "static/media/bearsanddolphins.4578c149.svg";